module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-human-w-540eca12c9e86e3a1a57341bec0b4645.svg";